import { FC, useState, ReactNode } from 'react';

import ResponsiveSearchDrawerItem, {
  ResponsiveDrawerInterface,
} from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveDrawer from '@components/views/components/listing/drawer/ResponsiveDrawer';

import { ResponsivePickerContent } from './ResponsiveSearchInputDrawerStyle';

const ResponsiveSearchInputDrawer: FC<
  Omit<ResponsiveDrawerInterface, 'onClick'> & { drawerTitle?: string } & {
    children: (child: () => void) => ReactNode;
  }
> = ({ children, drawerTitle, ...otherProps }) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const hideModal = () => {
    setIsShowModal(false);
  };

  return isShowModal ? (
    <ResponsiveDrawer
      title={drawerTitle}
      visible={isShowModal}
      onClose={hideModal}
    >
      <ResponsivePickerContent>
        {children && children(hideModal)}
      </ResponsivePickerContent>
    </ResponsiveDrawer>
  ) : (
    <ResponsiveSearchDrawerItem
      {...otherProps}
      onClick={() => setIsShowModal(true)}
    />
  );
};

export default ResponsiveSearchInputDrawer;
